
import Challenges from "../employee-recognition/Challenges";

export { Page }

function Page() {
  return <Challenges />;
}
